interface RetailAppRemoteConfig {
  [name: string]: boolean;
}

import remoteConfigDefaults from './remote-config-defaults.json';

export { RetailAppRemoteConfig, remoteConfigDefaults };
